module.exports = __webpack_public_path__ + "static/logo-cb751322593d6adcc5b4e495cfc51c66.png";